import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';

import TextField from '@material-ui/core/TextField';
import AutoComplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';

import * as ArchitectActions from '../actions/architectActions';
import * as K2ACoreActions from '../actions/k2aCoreActions';

import * as classes from './BobClientSelector.module.css';

const BobEntitySelector = ({
    fetchEquipmentBySiteId,
    fetchSystemsBySiteId,
    value,
    errors,
    handleChange,
    siteId,
    touched,
    label,
    required,
    disabled,
    ...props
}) => {
    const [filteredEntitiesList, setFilteredEntitiesList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [entityValue, setEntityValue] = useState({});

    useEffect(() => {
        const init = async () => {
            setLoading(true);
            const equipments = await fetchEquipmentBySiteId(siteId.id);
            equipments.forEach(item => {
                item.groupName = 'Equipment';
            });

            const systems = await fetchSystemsBySiteId(siteId.id);
            systems.forEach(item => {
                item.groupName = 'System';
            });
            
            const entities = equipments.concat(systems);

            setFilteredEntitiesList(entities);
            setLoading(false);
        };

        if (siteId && siteId.id) init();
    }, [siteId]);

    useEffect(() => {
        setEntityValue(value);
    }, [value]);

    return (
        <AutoComplete
            id="entityId"
            name="entityId"
            options={filteredEntitiesList.sort((a, b) => -b.groupName.localeCompare(a.groupName))}
            getOptionLabel={(option) => option.name || ''}
            groupBy={(option) => option.groupName}
            value={entityValue}
            getOptionSelected={(option, value) => option.name === value.name}
            onChange={(event, value) => handleChange(event, value)}
            size="small"
            disabled={disabled}
            required
            renderInput={(params) =>
                <TextField
                    {...params}
                    className={classes.Required}
                    label={label}
                    variant="outlined"
                    required={required}
                    error={errors ? true : false}
                    helperText={errors ? errors : null}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={15} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />}
        />
    );
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...K2ACoreActions
};

export default connect(null, mapDispatchToProps)(BobEntitySelector);
